<template>
  <section>
    <section class="main" v-if="windowSize > 991">
      <LeftBarVue id="LeftBarVue" class="left-bar" />
      <div id="column-center">
        <div id="header-bar"><HeaderVue /></div>
        <div class="main-area">
          <router-view />
          <v-tour name="Tour" :steps="steps"></v-tour>
        </div>
      </div>
    </section>
    <section v-if="windowSize <= 991" class="main-movil">
      <div class="header-movil">
        <SearchButtonVue :sizeButton="45" :movil="true" v-if="$route.path != '/accountsettings'"/>
        <div v-if="$route.path === '/accountsettings'"></div>
        <!-- <HelpButtonMovilVue :sizeButton="45" :movil="true" /> -->
        <div></div>
        <NotificationButtonVue />
      </div>
      <div class="content-movil">
        <router-view />
        <v-tour name="Tour" :steps="steps"></v-tour>
      </div>
      <div class="navbar-movil">
        <NavBarVue />
      </div>
    </section>
    <HelpButtonVue v-if="$route.path == '/'" :callback="startTour" />
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import HeaderVue from "../components/Header/Header.vue";
//import HelpButtonMovilVue from "../components/Header/HelpButtonMovil.vue";
import NotificationButtonVue from "../components/Header/NotificationButton.vue";
import SearchButtonVue from "../components/Header/SearchButton.vue";
import HelpButtonVue from "../components/HelpButton.vue";
import LeftBarVue from "../components/LeftBar.vue";
import NavBarVue from "../components/NavBar.vue";
export default {
  components: {
    HelpButtonVue,
    HeaderVue,
    LeftBarVue,
    //HelpButtonMovilVue,
    SearchButtonVue,
    NotificationButtonVue,
    NavBarVue,
  },
  data: () => ({
    steps: [],
    windowSize: 0,
    enableBtnHelp: true,
  }),
  computed: {
    ...mapGetters(["getOpenBar"]),
    ...mapGetters("Tours", ["getProjects", "getUserConfigure", "getDashBoard"]),
  },
  watch: {
    getOpenBar(value) {
      if (value) {
        document.getElementById("LeftBarVue").style.width = "4%";
        document.getElementById("header-bar").style.width = "96%";
        document.getElementById("header-bar").style.left = "4%";
        document.getElementById("column-center").style.width = "96%";
        document.getElementById("column-center").style.marginLeft = "4%";
      } else {
        document.getElementById("LeftBarVue").style.width = "0";
        document.getElementById("header-bar").style.width = "100%";
        document.getElementById("header-bar").style.left = "0";
        document.getElementById("column-center").style.width = "100%";
        document.getElementById("column-center").style.marginLeft = "0";
      }
    },
    $route() {
      this.defineTour();
      this.$tours["Tour"].stop();
    },
  },
  methods: {
    ...mapMutations(["setPhaseSelected"]),
    refactorWindow() {
      this.windowSize = window.innerWidth;
    },
    startTour() {
      this.setPhaseSelected("1");
      this.$tours["Tour"].start();
    },
    defineTour() {
      const { path } = this.$route;
      switch (path) {
        case "/":
          this.enableBtnHelp = false;
          this.steps = this.getProjects;
          break;
        case "/accountsettings":
          this.enableBtnHelp = false;
          this.steps = this.getUserConfigure;
          break;
        default:
          this.steps = this.getDashBoard;
          break;
      }
    },
  },
  mounted() {
    this.refactorWindow(true);
    window.addEventListener("resize", this.refactorWindow);
    this.defineTour();
  },
  destroyed() {
    window.removeEventListener("resize", this.refactorWindow);
  },
};
</script>

<style>
.main {
  width: 100%;
  height: 100vh;
  display: flex;
}
#column-center {
  margin-top: 50px;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  width: 96%;
  transition: 0.5s;
}
#LeftBarVue {
  position: fixed;
  top: 0;
  left: 0;
  width: 4%;
  transition: 0.5s;
  z-index: 1;
}
#header-bar {
  width: 96%;
  position: fixed;
  top: 0;
  left: 4%;
  transition: 0.5s;
  z-index: 10;
}
.main-area {
  padding: 15px 25px;
}
.main-movil {
  background: var(--firts-color);
  padding-top: 10%;
  width: 100%;
}
.main-movil .header-movil {
  padding: 5px 0;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: var(--firts-color);
  z-index: 5;
}
.main-movil .header-movil h1 {
  font-family: "PT Sans", sans-serif;
  font-weight: bold;
  font-size: 3rem;
  margin: 0;
  color: white;
  text-transform: uppercase;
}
.main-movil .content-movil {
  max-width: 100%;
  padding: 20px 20px 20% 20px;
  height: auto;
  background: #fff;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}
.main-movil .navbar-movil {
  z-index: 3;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  background: var(--firts-color);
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}
.main-movil .navbar-movil .item-perfil-movil {
  display: flex;
  flex-direction: column;
}
.main-movil .navbar-movil .img-profile {
  width: 55px;
  height: 55px;
}
.main-movil .navbar-movil .img-profile img {
  width: 100%;
  border-radius: 100%;
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/
@media (max-width: 767px) {
  .main-movil .header-movil h1 {
    font-family: "PT Sans", sans-serif;
    font-weight: bold;
    font-size: 1rem;
    margin: 0;
    color: white;
    text-transform: uppercase;
  }
  .main-movil .content-movil {
    margin-top: 10px;
  }
}
</style>